function getAnnotationId(event) {
  const element = event.nativeEvent.target.closest(
    '[data-custom-annotation-id]',
  );

  return element ? element.getAttribute('data-custom-annotation-id') : null;
}

export function getSelectedAnnotation(event, instance) {
  instance.setSelectedAnnotation(event.annotation);

  return instance.getSelectedAnnotation();
}

export function toggleAllLinksVisibility(isEnabled: boolean, instance) {
  if (isEnabled) {
    instance.contentDocument.body.classList.add('Cortlex-Show-All-Links');
  } else {
    instance.contentDocument.body.classList.remove('Cortlex-Show-All-Links');
  }
}

export function isClickedOnElementWithId(event, id) {
  const target = event?.nativeEvent?.target ?? event?.target;
  return (
    target && (target.closest('#' + id) || target.getAttribute('id') === id)
  );
}

export function isClickedOnElementWithClass(event, className) {
  const target = event?.nativeEvent?.target ?? event?.target;
  return (
    (target && target.closest('.' + className)) ||
    target.classList.contains(className)
  );
}
